import Result, { ok, error } from "../types/result";

type UnauthorizedHandler = (response: Response) => void;
let unauthorizedHandler: UnauthorizedHandler | null = null;

export const setUnauthorizedHandler = (fn: UnauthorizedHandler | null): void => {
  unauthorizedHandler = fn;
};

export const runUnauthorizedHandler = (response: Response): void => {
  unauthorizedHandler?.(response);
};

export async function parseResponse<T>(response: Response): Promise<Result<T>> {
  if (response.status === 401) {
    runUnauthorizedHandler(response);
  }

  const body = await response.json();

  if (response.ok) {
    return ok(body);
  } else if (body?.message?.reason && body?.message?.errors) {
    return error({
      tag: "validationError",
      message: body.message.reason,
      errors: body.message.errors,
      trace: body?.trace
    });
  } else if (body?.message?.reason) {
    return error({ tag: "traceError", message: body.message.reason, trace: body?.trace });
  } else if (body.message) {
    return error({ tag: "traceError", message: body.message, trace: body.trace });
  } else if (typeof body?.detail === "string") {
    return error({ tag: "traceError", message: body.detail, trace: body?.trace });
  } else if (body.detail && Array.isArray(body.detail)) {
    // pydantic error
    const { msg: message } = body.detail?.[0] || "";
    const badValue = body.detail?.[0]?.input?.[0] || "";
    return error({ tag: "valueError", message, value: badValue });
  } else {
    // TODO maybe throw here
    return error({ tag: "unknownError", message: "An unknown error occured" });
  }
}
